var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "solutions-container" }, [
    _vm.title
      ? _c("h4", { staticClass: "title font-bold mb-5 pb-4 text-center" }, [
          _vm._v(_vm._s(_vm.title))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid" },
      _vm._l(_vm.blocks, function(block) {
        return _c(
          "div",
          {
            key: block.key,
            staticClass: "card",
            attrs: {
              id: block.key,
              img: block.img,
              title: _vm.$t("solutions." + block.key + ".title"),
              description: _vm.$t("solutions." + block.key + ".description"),
              action: function() {},
              visible: ""
            }
          },
          [
            _c("img", {
              staticClass: "mb-4 icon",
              attrs: { src: block.img, alt: "" }
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "text-lg font-semibold" }, [
              _vm._v(_vm._s(_vm.$t("solutions." + block.key + ".title")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-gray-600" }, [
              _vm._v(_vm._s(_vm.$t("solutions." + block.key + ".description")))
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1ac0b06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1ac0b06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/landing/Blocks2x2Section.vue
// module id = 4469
// module chunks = 52